import { combineReducers } from 'redux';

import { utilReducer } from './modules/utils';
import { motoboyInfoReducer } from './modules/motoboy-info';
import { franchiseReducer } from './modules/franchise';
import { authReducer } from './modules/auth';
import { placesReducer } from './modules/places';
import { layoutReducer } from './modules/layout';
import { membersReducer } from './modules/members';
import { deliveriesReducer } from './modules/deliveries';
import { deliveryModelReducer } from './modules/delivery-model/slice';
import { filtersReducer } from './modules/filters/slice';

export const reducers = combineReducers({
  auth: authReducer,
  franchises: franchiseReducer,
  layout: layoutReducer,
  motoboyInfo: motoboyInfoReducer,
  places: placesReducer,
  members: membersReducer,
  deliveries: deliveriesReducer,
  utils: utilReducer,
  deliveryModel: deliveryModelReducer,
  filters: filtersReducer,
});

export type RootState = ReturnType<typeof reducers>;
